"use strict";
import ExpandToggle from "@threespot/expand-toggle";

class Nav {
  constructor() {
    // NOTE: breakpoint must match $layout-nav-bp in _layout-vars.scss
    this.mediaQueryList = window.matchMedia('(min-width: 1200px)');
    this.mobileMenuToggle = document.querySelector(
      ".HeaderMobileBar-button--menu"
    );

    this.navToggles = document.querySelectorAll("[data-nav-toggle]");
    this.mobileNavMenu = document.getElementById("mobileNav");
    this.mobileDrawerToggles = document.querySelectorAll("[data-nav-drawer-toggle]");
    this.mobileNavText = document.querySelector(".HeaderMobileBar-button-text");

    this.navExpandToggles = [];
    this.mobileCloseBtns = [];
    this.mobileDrawerExpandToggles = [];

    // Init on load
    this.init();
    this.addEventListeners();
  }

  addEventListeners() {
    // Close nav if click occurs outside of it
    window.addEventListener("click", (evt) => {
      this.navExpandToggles.forEach((toggle) => {
        // Close on link click
        if (evt.target.closest(".Navigation-sublist-link")) {
          toggle.collapse();
          this.mobileMenuToggle.setAttribute("aria-expanded", false);
          // We must also close the mobile nav menu and change the aria text
          this.mobileNavMenu.setAttribute("aria-hidden", true);
          this.mobileNavText.textContent = "Menu";
        }
        // Check if the element click is not the parent or contained by the parent of the toggle
        // This prevents any expanded toggles from being closed if the click occurs from within their parent element
        if (evt.target.closest(".Navigation-list-item") !== toggle.el.closest(".Navigation-list-item")) {
          toggle.collapse();
        }

        // Do the same for secondary nav
        if (evt.target.closest(".SecondaryNavigation-list-item") !== toggle.el.closest(".SecondaryNavigation-list-item")) {
          toggle.collapse();
        }
      });
    });

    document.documentElement.addEventListener("fonts-loaded", () => {
      this.navExpandToggles.forEach((toggle) => {
        toggle.updateExpandedHeight();
      });
    });

    window.addEventListener("resize", () => {
      this.navExpandToggles.forEach((toggle) => {
        toggle.updateExpandedHeight();
      });
    });

    // Close menu on link click inside of the mobile nav
    this.mobileNavMenu.addEventListener('click', (e) => {
      let { target } = e;

      if (target.tagName === 'A') {
        this.mobileExpandToggle.collapse();
      }
    });
  }

  init() {
    // Initialize mobile toggle
    this.mobileExpandToggle = new ExpandToggle(this.mobileMenuToggle);

    // Store generated toggles
    [].forEach.call(this.navToggles, (el) => {
      let closeBtn = document.querySelector(`[data-close='${el.getAttribute('data-expands')}']`);
      let toggle = new ExpandToggle(el);
      this.navExpandToggles.push(toggle);

      // Add close button functionality if there is a close button
      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          toggle.collapse();
        });

        this.mobileCloseBtns.push(closeBtn);
      }

      // Update nav menu height when a sublist is expanded or collapsed
      toggle.on("expand", () => {
          this.mobileExpandToggle.updateExpandedHeight();

          // Mobile view
          if (!this.mediaQueryList.matches) {
            // Change the max-height to 100% so the drawer expands to entire height of the menu
            toggle.targetEl.style.maxHeight = '100%';

            this.mobileNavMenu.scrollIntoView(true);
          }
      });
    });

    // Init or destroy drawers since they only work in mobile view
    if (!this.mediaQueryList.matches) {
      this.initMobileDrawers();
    } else {
      this.destroyMobileDrawers();
    }

    this.mediaQueryList.addEventListener('change', (evt) => {
      if (!evt.matches) {
        this.initMobileDrawers();
      } else {
        this.destroyMobileDrawers();
      }
    });
  }

  initMobileDrawers() {
    [].forEach.call(this.mobileDrawerToggles, (el) => {
      let closeBtn = document.querySelector(`[data-close='${el.getAttribute('data-expands')}']`);
      let toggle = new ExpandToggle(el);
      this.mobileDrawerExpandToggles.push(toggle);

      // Add close button functionality if there is a close button
      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          toggle.collapse();
        });

        this.mobileCloseBtns.push(closeBtn);
      }

      // Update nav menu height when a sublist is expanded or collapsed
      toggle.on("expand", () => {
          this.mobileExpandToggle.updateExpandedHeight();
          // Change the max-height to 100% so the drawer expands to entire height of the menu
          toggle.targetEl.style.maxHeight = '100%';
      });
    });
  }

  destroyMobileDrawers() {
    this.mobileDrawerExpandToggles.forEach(item => {
      item.destroy();
    });

    this.mobileDrawerExpandToggles = [];
  }
}

const init = () => {
  new Nav();
};

// Init on initial page load
init();
